import { Icon } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { OptionsDropdown } from '@hero/components/molecules';
import { ORGANIZATION_USER_STATUSES } from '@hero/constants';
import { useDeleteModalTemplate, useIsAdminOrganization } from '@hero/hooks';
import { ROUTE_PATHS } from '@hero/routes';
import {
  useGetUser,
  useRemoveOrganizationUser,
  useResendOrganizationUser
} from '@hero/services/organization-service/hooks';

function ActionCell({ row }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsync: resendOrganizationUser } = useResendOrganizationUser();
  const { data: me } = useGetUser();
  const { mutateAsync: removeOrganizationUser } = useRemoveOrganizationUser();
  const isOrganizationAdmin = useIsAdminOrganization();
  const { showDeleteModal } = useDeleteModalTemplate({
    confirmText: 'DELETE USER',
    title: t('areYouSureYouWantDelete', { type: t('user').toLowerCase() }),
    message: t('deleteUserConfirmMessage')
  });

  const options = [];

  if (row.original.status !== ORGANIZATION_USER_STATUSES.pendingInvite) {
    options.push({
      label: t('seeDetails'),
      onClick: () => {
        navigate(ROUTE_PATHS.SETTINGS_USERS_DETAIL(row.original.code));
      }
    });
  }
  if (
    row.original.status === ORGANIZATION_USER_STATUSES.pendingInvite ||
    row.original.status === ORGANIZATION_USER_STATUSES.expiredInvite
  ) {
    options.push({
      label: t('resendInvite'),
      onClick: () => {
        resendOrganizationUser({
          inviteCodes: [row.original.invite.code]
        });
      }
    });
  }

  if (row.original.email !== me.email && row.original.role !== isOrganizationAdmin) {
    options.push({
      label: t('removeUser'),
      onClick: () => onRemoveUserClick(row),
      style: {
        color: 'var(--color-error-default)'
      }
    });
  }

  function onRemoveUserClick(row) {
    showDeleteModal({
      onSubmit: () => {
        removeOrganizationUser({
          userCodes: [row.original.code]
        });
      }
    });
  }

  return (
    <OptionsDropdown
      disabled={row.original.role === isOrganizationAdmin}
      popperOptions={{
        placement: 'left',
        modifiers: [
          {
            name: 'offset',
            enabled: true,
            options: {
              offset: [50, 0]
            }
          }
        ]
      }}
      options={options}
    >
      <Icon name="3dot" px={18} />
    </OptionsDropdown>
  );
}

ActionCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      code: PropTypes.string,
      status: PropTypes.string,
      email: PropTypes.string,
      role: PropTypes.string,
      invite: PropTypes.shape({
        code: PropTypes.string
      })
    })
  })
};

export { ActionCell };
